/**
 * LE calcul des indemnités (CDC §4 et §5.3, règles RH 3.3.1 et 3.4).
 *
 * Il vit ICI et nulle part ailleurs : l'écran l'appelle pour afficher le montant
 * au collaborateur avant qu'il soumette (§6.1 « consulte le montant calculé »),
 * et l'API le rejoue à chaque écriture pour ce qui est enregistré. Deux
 * implémentations finiraient par diverger, et c'est l'API qui paierait l'écart.
 *
 * Indemnité de grand déplacement (IGD) :
 *   X        = km aller-retour − franchise (80 km : 40 aller + 40 retour)
 *   heures   = X / 120
 *   montant  = heures × SMIC horaire × 2
 * Due seulement si la distance aller-retour dépasse le seuil.
 *
 * Indemnité de nuitée : montant forfaitaire (30 €) × nombre de nuitées.
 *
 * Tous les chiffres (seuil, diviseur, SMIC, coefficient, forfait) viennent du
 * BARÈME en vigueur à la date du déplacement (§4.3) : un déplacement de mars
 * reste payé au SMIC de mars même si la déclaration est validée en avril.
 */
/** Arrondi monétaire au centime, sans l'erreur binaire de Math.round(x*100)/100 sur 1.005. */
export function arrondiCentimes(v) {
    return Math.round((v + Number.EPSILON) * 100) / 100;
}
/** Arrondi des heures et km à 2 décimales, pour l'affichage et le stockage. */
const arrondi2 = arrondiCentimes;
export function calculerIndemnites(entree, bareme) {
    const aller = Number.isFinite(entree.distanceAllerKm) && entree.distanceAllerKm > 0 ? entree.distanceAllerKm : 0;
    const kmAllerRetour = arrondi2(aller * 2);
    // « Supérieure à 80 km » (§4.1) : strictement. À 80 km pile, X vaudrait 0 —
    // le résultat serait le même, mais le badge « éligible » mentirait.
    const eligibleIgd = kmAllerRetour > bareme.seuilKmAllerRetour;
    const kmIndemnises = eligibleIgd ? arrondi2(kmAllerRetour - bareme.seuilKmAllerRetour) : 0;
    const heuresIndemnisees = eligibleIgd && bareme.diviseurKmHeure > 0 ? arrondi2(kmIndemnises / bareme.diviseurKmHeure) : 0;
    // Le montant se calcule sur les heures NON arrondies : arrondir d'abord les
    // heures puis multiplier ferait dériver le montant de plusieurs centimes.
    const heuresExactes = eligibleIgd && bareme.diviseurKmHeure > 0 ? kmIndemnises / bareme.diviseurKmHeure : 0;
    const montantIgd = arrondiCentimes(heuresExactes * bareme.smicHoraire * bareme.coefficientSmic);
    const nb = entree.nuitee && Number.isInteger(entree.nbNuitees) && entree.nbNuitees > 0 ? entree.nbNuitees : 0;
    const montantNuitee = arrondiCentimes(nb * bareme.montantNuitee);
    return {
        kmAllerRetour,
        kmIndemnises,
        heuresIndemnisees,
        eligibleIgd,
        montantIgd,
        montantNuitee,
        montantTotal: arrondiCentimes(montantIgd + montantNuitee),
    };
}
/** Formatage monétaire français, partagé pour que l'écran et l'export disent le même chiffre. */
export function formatEuros(v) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(v);
}
//# sourceMappingURL=calcul.js.map